const course = () => import('@/page/course')
const courseList = () => import('@/page/course/course-list')
const courseDetail = () => import('@/page/course/course-detail')
const courseTopics = () => import('@/page/course/course-topics')
export default [
  {
    path: '/course',
    name: 'course',
    component: course,
    children: [
      {
        path: 'course-list',
        name: 'course-list',
        component: courseList
      },
      {
        path: 'course-detail',
        name: 'course-detail',
        component: courseDetail
      },
      {
        path: 'course-topics',
        name: 'course-topics',
        component: courseTopics
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/course/index.js